import "./styles.css";

export default function Loading() {
  return <div className="loading-component"></div>;
}
